import { useState } from 'react';

import Transition from '@/components/Common/Transition';

import type { CreateTopicModalProps } from '../types';
import ReviewAiTopic from './ReviewAiTopic';
import SelectAiTopic from './SelectAiTopic';
import type { CandidateItemT } from './types';

enum STEP {
  SELECT = 1,
  REVIEW,
}

const CreateAiTopicContainer = <T extends CreateTopicTarget>(
  props: CreateTopicModalProps<T> & {
    closeModal: () => void;
    initialCsvData?: CandidateItemT[] | null;
  },
) => {
  // CSV 데이터가 있으면 REVIEW 단계로 바로 시작
  const [step, setStep] = useState(
    props.initialCsvData ? STEP.REVIEW : STEP.SELECT,
  );
  const [selectedItems, setSelectedItems] = useState<CandidateItemT[]>(
    props.initialCsvData || [],
  );

  return (
    <Transition
      status={step === STEP.REVIEW}
      fallback={
        <SelectAiTopic
          selectedItems={selectedItems}
          setSelectedItems={setSelectedItems}
          onCancelClick={props.closeModal}
          onNextClick={() => setStep(STEP.REVIEW)}
        />
      }
    >
      <ReviewAiTopic
        selectedItems={selectedItems}
        setSelectedItems={setSelectedItems}
        onBackClick={() => setStep(STEP.SELECT)}
        onSubmitSuccess={props.closeModal}
        {...props}
      />
    </Transition>
  );
};

export default CreateAiTopicContainer;
